import React from 'react';
import { Field } from 'react-final-form';
import { map } from 'ramda';

import Input from 'components/common/form/Input';
import DatePicker from 'components/common/form/DatePicker';
import Text from 'components/common/form/Text';
import { SelectLoadComponent } from 'components/common/form/Select';

const componentsTypes = {
    Input: Input,
    DatePicker: DatePicker,
    SelectLoad: SelectLoadComponent,
};

const XMLFields = ({ fieldsXML, translatePrefix }) => {
    return (
        <div>
            { map(({ name, label, text, type, autoSize, maxLength, disabled, options }) => (
                    <div key={name}>
                        <Field
                            name={`result.xmlbody.${name}`}
                            component={componentsTypes[type] || Text}
                            label={{
                                content: `xml.${translatePrefix}.${label}`,
                                text
                            }}
                            maxLength={maxLength || '2023'}
                            autoSize={autoSize}
                            disabled={disabled}
                            {...options}
                        />
                    </div>
                )
            , fieldsXML) }
        </div>
    );
};

export default XMLFields;
